module.exports = __webpack_public_path__ + "img/Finish Later.75abb309.svg";